var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 10.237288,
    x2: 10.14716,
    xlinkHref: "#c",
    y1: 13.544356,
    y2: 31.307068
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 22.237288,
    x2: 22.14716,
    xlinkHref: "#c",
    y1: 13.544356,
    y2: 31.307068
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 94.47298,
    x2: 94.47298,
    y1: 175.992366,
    y2: 289.294316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#393536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393536",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.20339 13.423729h3.977668v17.868372h-3.977668z",
    fill: "url(#a)",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.20339 13.423729h3.977668v17.868372h-3.977668z",
    fill: "url(#b)",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainShadow);
export default __webpack_public_path__ + "static/media/train-shadow.b91757c39a80e4623694f74922657cbb.svg";
export { ForwardRef as ReactComponent };